/**
 * Keys that mutate an object's prototype chain rather than adding an own
 * property. Writing to any of them with a caller-supplied name lets an attacker
 * change behaviour for every object in the app (prototype pollution), so they
 * are rejected before being used as a write target.
 */
const UNSAFE_OBJECT_KEYS: readonly string[] = [
  '__proto__',
  'constructor',
  'prototype',
]

/**
 * Returns true when `key` must not be used as a property name to write to.
 */
export const isUnsafeObjectKey = (key: string): boolean =>
  UNSAFE_OBJECT_KEYS.includes(key)
